import type { ShipmentListRow } from '@/types/shipments';
import { isShipmentArchived } from '@/types/shipments';

export function isDraftShipment(
  row: Pick<ShipmentListRow, 'status'>,
): boolean {
  return String(row.status ?? '').toLowerCase() === 'draft';
}

export function canEditShipmentForUser(
  row: ShipmentListRow,
  canManage: boolean,
): boolean {
  if (!canManage) return false;
  if (isShipmentArchived(row)) return false;
  return true;
}
